var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "complaint-page" }, [
    _c("header", { staticClass: "topbar" }, [
      _c(
        "a",
        {
          staticClass: "record-link",
          attrs: { href: "javascript:;" },
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "tousujilu" })
            }
          }
        },
        [
          _c("span", [_vm._v("投诉记录")]),
          _vm._v(" "),
          _c(
            "svg",
            { attrs: { viewBox: "0 0 12 12", "aria-hidden": "true" } },
            [
              _c("path", {
                attrs: {
                  d: "M3.5 2l5 4-5 4",
                  fill: "none",
                  stroke: "rgba(153,153,153,1)",
                  "stroke-width": "2.2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              })
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card" }, [
      _c("label", { staticClass: "field" }, [
        _c("span", { staticClass: "label" }, [_vm._v("iccid/短号")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.iccid,
              expression: "form.iccid"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.form.iccid },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "iccid", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "field" }, [
        _c("span", { staticClass: "label" }, [_vm._v("联系人")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.name,
              expression: "form.name"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.form.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "field" }, [
        _c("span", { staticClass: "label" }, [_vm._v("联系电话")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.mobile,
              expression: "form.mobile"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.form.mobile },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "mobile", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card" }, [
      _c("label", { staticClass: "field textarea-field" }, [
        _c("span", { staticClass: "label" }, [_vm._v("问题描述")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.desc,
              expression: "form.desc"
            }
          ],
          domProps: { value: _vm.form.desc },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "desc", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card attachment-card" }, [
      _c("h2", { staticClass: "label attachment-title" }, [_vm._v("附件")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attachment-row" },
        [
          _c(
            "van-uploader",
            {
              attrs: {
                "preview-size": "1.02rem",
                "max-count": 6,
                multiple: ""
              },
              model: {
                value: _vm.fileList,
                callback: function($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList"
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "upload-btn",
                  attrs: { type: "button", "aria-label": "添加附件" }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("./static/images/complaint/shangchuan.png"),
                      alt: ""
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "submit-btn",
        attrs: { type: "button" },
        on: { click: _vm.handleBindCard }
      },
      [_vm._v("提交反馈")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18f3fa84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f3fa84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/feedback.vue
// module id = null
// module chunks = 